var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"commodity-wrapper"},[_c('info-goods-swipe'),_c('info-item'),_c('info-buy'),_c('recommend-item'),_c('div',{staticStyle:{"height":"0.25rem","background-color":"#F0F2F5"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }